import React from 'react';
import { RouteParams } from 'types/routes/route-params';
import { SecurityFactory } from 'security/security-factory';

const RouteElement: React.FC<RouteParams> = (routeProp: RouteParams) => {
    const { element: Component, ...routeParams } = routeProp;

    return (
        <>
            <SecurityFactory securityType={routeParams.rules.securityType}>
                <Component
                    key={routeParams.name}
                    type
                    props={routeParams.props}
                />
            </SecurityFactory>
        </>
    );
};

export default RouteElement;
